// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@media screen and (max-width: 600px) {
  .hide-sm {
    display: none !important;
  }

  .d-inline-block.hide-sm {
    display: none !important;
  }
}
html body {
  max-width: 100%;
  max-height: 100vh;
  font-size: 0.9rem;
}

.event-disabled {
  opacity: 0.6;
}
.psb-divider {
  display:block;
  width:100%;
  margin:4px 0;
  border-bottom:solid 1px var(--psb-border-light);
}
.pull-right {
  float:right;
}
h1,h2,h3,h4,h5,h6{
  margin-bottom: 1.025rem;
}

@media (max-width: 600px) {
  .xs-psb-carded {
    background-color: #ffffff;
    border:solid 1px var(--psb-border-dark);
    border-radius: 12px;
    padding:15px;
    box-shadow: 0 8px 20px -12px rgba(29,28,42,0.35);
    margin-bottom: 20px;
  }
  .xs-psb-bordered {
    border:solid 1px var(--psb-border-dark);
    border-radius: 12px;
    padding:20px;
  }
}

.psb-carded {
  background-color: #ffffff;
  border:solid 1px var(--psb-border-dark);
  border-radius: 12px;
  padding:15px;
  box-shadow: 0 8px 20px -12px rgba(29,28,42,0.35);
}
.psb-bordered {
  border:solid 1px var(--psb-border-dark);
  border-radius: 12px;
  padding:20px;
}
.psb-bordered-inset {
  margin-left:12px;
  border-left:solid 2px var(--psb-border-dark);
}
.psb-dark-button {
  background: var(--psb-dark);
  color: #fff;
}
p {
  font-size:14px;
  line-height:1.2em;
  margin-bottom: 12px;
}
p small {
  font-size: 13px;
}
.modal-body {
  max-height: calc(100vh - 200px);
  overflow: hidden;
  overflow-y: auto;
}

.modal-overflow-100 {
  max-height: 95vh;
}

#psb-header {
  text-align: center;
  display: block;
  border: 1px solid var(--psb-border-light);
  background: var(--psb-bg);
  padding-bottom: 4px;
  &.customer-header {
    background: #fff;
    border-bottom: solid 1px var(--psb-border-light);
    padding-top: 25px;
    top: 0;
    z-index: 2;
  }
}


.MuiPaper-root {
  border: none;
  border-radius: 14px;
  box-shadow: 0 1px 2px rgba(29,28,42,0.06), 0 12px 28px -14px rgba(29,28,42,0.28);
}

.MuiPaper-root:hover {
  box-shadow: 0 2px 4px rgba(29,28,42,0.08), 0 20px 40px -16px rgba(29,28,42,0.35);
}

#psb-header {
  text-align: center;
  display: block;
  border: 1px solid var(--psb-border-light);
  background: var(--psb-bg);
  padding-bottom: 4px;
}

.rounded-item {
  border: solid 1px red;
  border-radius: 200px;
  padding: 20px 10px;
  margin: -20px 0 -20px 0 !important;
}

.ck-editor__editable {
  min-height: 400px;
}

.ck.ck-balloon-panel.ck-balloon-panel_position_border-side_right.ck-powered-by-balloon {
  display: none;
  position: absolute;
  left: -99999em;
}


.modal {
  z-index: 1250;
}

.modal-backdrop {
  z-index: 1210;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-default {
  cursor: default;
}

.text-right {
  text-align: right;
}

.react-datepicker-wrapper {
  .form-control {
    font-size: 0.9rem;
    font-weight: 100;
    height: 2.6rem;
  }

  width: 100%;
}

.modal-picker {
  z-index: 999;
  position: relative;
}

a.fc-event {
  cursor: pointer;
}

.bg-invalid-event {
  cursor: auto;
  background: #ccc !important;
}

.modal-card {
  box-shadow: 0 12px 28px -14px rgba(29,28,42,0.35);
  border-radius: 14px;
}

.bg-primary {
  background: #a1c2e6 !important;
}

.bg-info {
  background: #A1C2E6C2 !important;
}

.underline {
  text-decoration: underline;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.spin {
  animation: spin 1000ms linear infinite;
}


.btn-close {
  --bs-btn-close-color: #000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--bs-btn-close-opacity);
}

.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}

.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}

.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
  user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  filter: var(--bs-btn-close-white-filter);
}


.tab-container {
  width: 100%; /* Or a specific width */
  overflow-x: auto; /* Enable horizontal scrolling */
  white-space: nowrap; /* Prevent tab items from wrapping */
}

/* Optional: Hide scrollbar in webkit browsers */
.tab-container::-webkit-scrollbar {
  display: none;
}

.tab-navigation {
  display: flex; /* Arrange tab items horizontally */
  gap: 2px; /* Space between tab items */
  padding: 0; /* Add some padding if needed */
}

.tab-item {
  /* Basic styling for tab buttons */
  cursor: pointer;
  list-style: none;
  white-space: nowrap; /* Ensure text doesn't wrap within a tab item */
}

.tab-item.active {
  background-color: var(--psb-accent);
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,UAAU;EACV,YAAY;EACZ,+CAA+C;AACjD;AACA;EACE,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,yBAAyB;IACzB,uCAAuC;IACvC,mBAAmB;IACnB,YAAY;IACZ,gDAAgD;IAChD,mBAAmB;EACrB;EACA;IACE,uCAAuC;IACvC,mBAAmB;IACnB,YAAY;EACd;AACF;;AAEA;EACE,yBAAyB;EACzB,uCAAuC;EACvC,mBAAmB;EACnB,YAAY;EACZ,gDAAgD;AAClD;AACA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,4CAA4C;AAC9C;AACA;EACE,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yCAAyC;EACzC,yBAAyB;EACzB,mBAAmB;EACnB;IACE,gBAAgB;IAChB,gDAAgD;IAChD,iBAAiB;IACjB,MAAM;IACN,UAAU;EACZ;AACF;;;AAGA;EACE,YAAY;EACZ,mBAAmB;EACnB,gFAAgF;AAClF;;AAEA;EACE,gFAAgF;AAClF;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yCAAyC;EACzC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;EAChB;;EAEA,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAoBA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,sCAAsC;AACxC;;;AAGA;EACE,0BAA0B;EAC1B,0DAAoV;EACpV,2BAA2B;EAC3B,kCAAkC;EAClC,mEAAmE;EACnE,+BAA+B;EAC/B,qCAAqC;EACrC,uEAAuE;EACvE,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,gCAAgC;EAChC,wEAAwE;EACxE,SAAS;EACT,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,UAAU;EACV,4CAA4C;EAC5C,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EAEzB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,wCAAwC;AAC1C;;;AAGA;EACE,WAAW,EAAE,wBAAwB;EACrC,gBAAgB,EAAE,gCAAgC;EAClD,mBAAmB,EAAE,oCAAoC;AAC3D;;AAEA,gDAAgD;AAChD;EACE,aAAa;AACf;;AAEA;EACE,aAAa,EAAE,mCAAmC;EAClD,QAAQ,EAAE,4BAA4B;EACtC,UAAU,EAAE,+BAA+B;AAC7C;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,mBAAmB,EAAE,+CAA+C;AACtE;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd","sourcesContent":["@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .hide-sm {\n    display: none !important;\n  }\n\n  .d-inline-block.hide-sm {\n    display: none !important;\n  }\n}\nhtml body {\n  max-width: 100%;\n  max-height: 100vh;\n  font-size: 0.9rem;\n}\n\n.event-disabled {\n  opacity: 0.6;\n}\n.psb-divider {\n  display:block;\n  width:100%;\n  margin:4px 0;\n  border-bottom:solid 1px var(--psb-border-light);\n}\n.pull-right {\n  float:right;\n}\nh1,h2,h3,h4,h5,h6{\n  margin-bottom: 1.025rem;\n}\n\n@media (max-width: 600px) {\n  .xs-psb-carded {\n    background-color: #ffffff;\n    border:solid 1px var(--psb-border-dark);\n    border-radius: 12px;\n    padding:15px;\n    box-shadow: 0 8px 20px -12px rgba(29,28,42,0.35);\n    margin-bottom: 20px;\n  }\n  .xs-psb-bordered {\n    border:solid 1px var(--psb-border-dark);\n    border-radius: 12px;\n    padding:20px;\n  }\n}\n\n.psb-carded {\n  background-color: #ffffff;\n  border:solid 1px var(--psb-border-dark);\n  border-radius: 12px;\n  padding:15px;\n  box-shadow: 0 8px 20px -12px rgba(29,28,42,0.35);\n}\n.psb-bordered {\n  border:solid 1px var(--psb-border-dark);\n  border-radius: 12px;\n  padding:20px;\n}\n.psb-bordered-inset {\n  margin-left:12px;\n  border-left:solid 2px var(--psb-border-dark);\n}\n.psb-dark-button {\n  background: var(--psb-dark);\n  color: #fff;\n}\np {\n  font-size:14px;\n  line-height:1.2em;\n  margin-bottom: 12px;\n}\np small {\n  font-size: 13px;\n}\n.modal-body {\n  max-height: calc(100vh - 200px);\n  overflow: hidden;\n  overflow-y: auto;\n}\n\n.modal-overflow-100 {\n  max-height: 95vh;\n}\n\n#psb-header {\n  text-align: center;\n  display: block;\n  border: 1px solid var(--psb-border-light);\n  background: var(--psb-bg);\n  padding-bottom: 4px;\n  &.customer-header {\n    background: #fff;\n    border-bottom: solid 1px var(--psb-border-light);\n    padding-top: 25px;\n    top: 0;\n    z-index: 2;\n  }\n}\n\n\n.MuiPaper-root {\n  border: none;\n  border-radius: 14px;\n  box-shadow: 0 1px 2px rgba(29,28,42,0.06), 0 12px 28px -14px rgba(29,28,42,0.28);\n}\n\n.MuiPaper-root:hover {\n  box-shadow: 0 2px 4px rgba(29,28,42,0.08), 0 20px 40px -16px rgba(29,28,42,0.35);\n}\n\n#psb-header {\n  text-align: center;\n  display: block;\n  border: 1px solid var(--psb-border-light);\n  background: var(--psb-bg);\n  padding-bottom: 4px;\n}\n\n.rounded-item {\n  border: solid 1px red;\n  border-radius: 200px;\n  padding: 20px 10px;\n  margin: -20px 0 -20px 0 !important;\n}\n\n.ck-editor__editable {\n  min-height: 400px;\n}\n\n.ck.ck-balloon-panel.ck-balloon-panel_position_border-side_right.ck-powered-by-balloon {\n  display: none;\n  position: absolute;\n  left: -99999em;\n}\n\n\n.modal {\n  z-index: 1250;\n}\n\n.modal-backdrop {\n  z-index: 1210;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-default {\n  cursor: default;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.react-datepicker-wrapper {\n  .form-control {\n    font-size: 0.9rem;\n    font-weight: 100;\n    height: 2.6rem;\n  }\n\n  width: 100%;\n}\n\n.modal-picker {\n  z-index: 999;\n  position: relative;\n}\n\na.fc-event {\n  cursor: pointer;\n}\n\n.bg-invalid-event {\n  cursor: auto;\n  background: #ccc !important;\n}\n\n.modal-card {\n  box-shadow: 0 12px 28px -14px rgba(29,28,42,0.35);\n  border-radius: 14px;\n}\n\n.bg-primary {\n  background: #a1c2e6 !important;\n}\n\n.bg-info {\n  background: #A1C2E6C2 !important;\n}\n\n.underline {\n  text-decoration: underline;\n}\n\n@-moz-keyframes spin {\n  from {\n    -moz-transform: rotate(0deg);\n  }\n  to {\n    -moz-transform: rotate(360deg);\n  }\n}\n\n@-webkit-keyframes spin {\n  from {\n    -webkit-transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.spin {\n  animation: spin 1000ms linear infinite;\n}\n\n\n.btn-close {\n  --bs-btn-close-color: #000;\n  --bs-btn-close-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e\");\n  --bs-btn-close-opacity: 0.5;\n  --bs-btn-close-hover-opacity: 0.75;\n  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n  --bs-btn-close-focus-opacity: 1;\n  --bs-btn-close-disabled-opacity: 0.25;\n  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);\n  box-sizing: content-box;\n  width: 1em;\n  height: 1em;\n  padding: 0.25em 0.25em;\n  color: var(--bs-btn-close-color);\n  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;\n  border: 0;\n  border-radius: 0.375rem;\n  opacity: var(--bs-btn-close-opacity);\n}\n\n.btn-close:hover {\n  color: var(--bs-btn-close-color);\n  text-decoration: none;\n  opacity: var(--bs-btn-close-hover-opacity);\n}\n\n.btn-close:focus {\n  outline: 0;\n  box-shadow: var(--bs-btn-close-focus-shadow);\n  opacity: var(--bs-btn-close-focus-opacity);\n}\n\n.btn-close:disabled, .btn-close.disabled {\n  pointer-events: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  opacity: var(--bs-btn-close-disabled-opacity);\n}\n\n.btn-close-white {\n  filter: var(--bs-btn-close-white-filter);\n}\n\n\n.tab-container {\n  width: 100%; /* Or a specific width */\n  overflow-x: auto; /* Enable horizontal scrolling */\n  white-space: nowrap; /* Prevent tab items from wrapping */\n}\n\n/* Optional: Hide scrollbar in webkit browsers */\n.tab-container::-webkit-scrollbar {\n  display: none;\n}\n\n.tab-navigation {\n  display: flex; /* Arrange tab items horizontally */\n  gap: 2px; /* Space between tab items */\n  padding: 0; /* Add some padding if needed */\n}\n\n.tab-item {\n  /* Basic styling for tab buttons */\n  cursor: pointer;\n  list-style: none;\n  white-space: nowrap; /* Ensure text doesn't wrap within a tab item */\n}\n\n.tab-item.active {\n  background-color: var(--psb-accent);\n  color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
